export const LANGUAGES_COLUMN_TRANSITIONS_PROPS = {
    initial: {
        y: '50%'
    },
    animate: {
        y: 0
    }
};
